<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.applyRecord')"
    :batch-actions="batchActions"
    resource="apply_records"
    :actionColumnProps="{ width: 100 }"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/apply_records.js';
import { columnsExtend as studentColumnsExtend  } from '../admin_entities/student_detail.js';
import { columnsExtend as memberColumnsExtend  } from '../admin_entities/member_detail.js';
import _ from 'lodash';

@Component
export default class ApplyRecords extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const memberColumns = memberColumnsExtend([
      { key: 'know_channel', prop: 'user.member.know_channel' },
      { key: 'business_experience', prop: 'user.member.business_experience' },
      { key: 'vaccination_record_image', prop: 'user.member.vaccination_record_image' }
    ], { filterColumnsExtend })
    const studentColumns = studentColumnsExtend([
      { key: 'courses_count', prop: 'user.student.courses_count' },
      { key: 'nps_list', prop: 'user.student.nps_list' },
    ], { filterColumnsExtend })

    const array = [
      type === 'show' && 'id',
      {
        key: 'target',
        filterColumns: [{
          prop: 'target_id_eq',
          label: '等于',
          renderCell: {
            component: 'select',
            props: {
              clearable: true,
              xRemotePreload: async () => {
                const { data } = await this.$request.get('/posts/read_options', { per_page: 100, type_in: ['YouthCamp', 'BookClub'] });
                return data.map(item => ({ value: item.id, label: item.title }));
              },
              xRemoteSearch: async (keyword) => {
                const { data } = await this.$request.get('/posts/read_options', { keyword, type_in: ['YouthCamp', 'BookClub'] });
                return data.map(item => ({ value: item.id, label: item.title }));
              }
            }
          }
        }]
      },
      {
        key: 'user',
         filterColumns: [{
          prop: 'user_id_eq',
          label: '等于',
          renderCell: {
            component: 'select',
            props: {
              clearable: true,
              xRemotePreload: async () => {
                const { data } = await this.$request.get('/users/read_options', { per_page: 100 });
                return data.map(item => ({ value: item.id, label: item.screen_name }));
              },
              xRemoteSearch: async (keyword) => {
                const { data } = await this.$request.get('/users/read_options', { keyword });
                return data.map(item => ({ value: item.id, label: item.screen_name }));
              }
            }
          }
        }]
      },
      {
        prop: 'user.member.name',
        label: '学员名称',
        renderCell: (h, { props: { value, scope: { row } } }) => {
          return <span>{value || _.get(row, 'user.student.name') || '/'}</span>
        }
      },
      {
        key: 'state',
        width: 120,
      },
      { key: 'price_type_name', minWidth: 130 },
      { key: 'price_type_amount', minWidth: 130 },
      'refund_reason',
      { key: 'refund_reason_detail', minWidth: 155 },
      {
        prop: 'user.member.gender',
        label: this.$t('member.gender'),
        renderCell: (h, { props: { value, scope: { row } } }) => {
          return <span>{this.$t(`member.genders.${value || _.get(row, 'user.student.gender') || 'unknown'}`)}</span>
        }
      },
      {
        prop: 'user.member.live_city',
        label: this.$t('member.liveCity'),
        renderCell: (h, { props: { value, scope: { row } } }) => {
          return <span>{value || _.get(row, 'user.student.city') || '/'}</span>
        }
      },
      {
        prop: 'user.student.occupation',
        label: this.$t('student.occupation'),
        renderCell: (h, { props: { value, scope: { row } } }) => {
          return <span>{value || _.join(_.compact([_.get(row, 'user.member.company'), _.get(row, 'user.member.position')]))}</span>
        }
      },
      ...memberColumns,
      ...studentColumns,
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array, { filterColumnsExtend })
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [

    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      row.state === 'refund_audit' && {
        component: 'confirmButton',
        props: {
          label: '同意退款',
          type: 'danger',
          can: 'apply_records.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/apply_records/${row.id}/agree_refund`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.state === 'refund_audit' && {
        component: 'confirmButton',
        props: {
          label: '拒绝退款',
          type: 'primary',
          can: 'apply_records.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/apply_records/${row.id}/refuse_refund`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'apply_records.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>导出</el-button>
    ];
  }
}

export const route = [
  {
    path: '/apply_records',
    name: 'apply_records.index',
    component: ApplyRecords,
    props: {
      type: 'index',
    }
  },
  {
    path: '/apply_records/new',
    name: 'apply_records.new',
    component: ApplyRecords,
    props: {
      type: 'new',
    }
  },
  {
    path: '/apply_records/:id',
    name: 'apply_records.show',
    component: ApplyRecords,
    props: {
      type: 'show',
    }
  },
  {
    path: '/apply_records/:id/edit',
    name: 'apply_records.edit',
    component: ApplyRecords,
    props: {
      type: 'edit'
    }
  }
]
</script>
